import { InMemoryCache } from "apollo-cache-inmemory";
import { ApolloClient } from "apollo-client";
import { createUploadLink } from "apollo-upload-client";

export const client = new ApolloClient({
  link: createUploadLink({
    uri: process.env.GRAPHQL_URI,
    credentials: "include"
  }),
  cache: new InMemoryCache(),
  connectToDevTools: true
});



// WEBPACK FOOTER //
// ./src/apollo.js